module.exports = __webpack_public_path__ + "img/charak_katan_no.8d75264d.png";